import { Box, Icon, SxProps } from "@outschool/backpack";
import { IconDefinition, faTimes } from "@outschool/icons";
import { IconButton, Input } from "@outschool/ui-legacy-component-library";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

const inputWrapperStyle: SxProps = {
  backgroundColor: "common.white",
  border: "1px solid",
  borderColor: "grey.500",
  borderRadius: "0.5em",
  padding: "0.25em",
  flex: 1,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  overflow: "hidden",
};

const inputStyle: SystemStyleObject = {
  cursor: "pointer",
  width: "100%",
  flexGrow: 1,
  fontSize: "1.6rem",
  border: "none !important", // TODO: Better solution for inputs containing buttons
  "&::placeholder": {
    color: "grayText",
  },
  "&:focus": {
    outline: "none",
    border: "none",
  },
};

const iconStyle: SxProps = {
  border: 0,
  height: "38px",
  width: 0,
  marginLeft: "0.5em",
  fontSize: "1.6rem",
  color: "grey.500",
  background: "transparent",
  "&:active": {
    color: "grey.500",
  },
  "&:hover": {
    color: "grey.500",
  },
};

const clearButtonStyle: SystemStyleObject = {
  border: 0,
  height: "38px",
  width: 0,
  marginLeft: "0.5em",
  fontSize: "1.6rem",
  background: "transparent",
  color: "grayText",
  padding: "0 25px 0 10px",
  "&:active": {
    color: "grayText",
  },
  "&:hover": {
    color: "grayText",
  },
};

export type TypeaheadProps = {
  "aria-autocomplete": "none" | "inline" | "both" | "list";
  "aria-controls": string;
  "aria-labelledby": string;
  autoComplete: string;
  id: string;
  onBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  ref?: React.MutableRefObject<HTMLInputElement>;
  value?: string;
};

type SearchInputFieldProps = {
  placeholder?: string;
  value?: string;
  icon?: IconDefinition;
  showClearButton?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  onClick?: () => void;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef?: React.MutableRefObject<HTMLInputElement>;
  inputId?: string;
  typeaheadProps?: TypeaheadProps;
};

export function SearchInputField({
  placeholder = "nothing",
  value = "",
  icon,
  showClearButton = false,
  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e);
    return;
  },
  onClear,
  onClick,
  onFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.placeholder = "";
    return;
  },
  onKeyDown,
  inputRef,
  inputId,
  typeaheadProps,
}: SearchInputFieldProps) {
  const localRef = React.useRef();
  const ref = inputRef || localRef;

  return (
    <Box sx={inputWrapperStyle} onClick={onClick}>
      {icon && <Icon sx={iconStyle} icon={icon} />}
      <Input
        id={inputId}
        ref={ref}
        sx={inputStyle}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        {...typeaheadProps}
      />
      {!!showClearButton && (
        <IconButton
          sx={clearButtonStyle}
          type="button"
          icon={faTimes}
          onClick={() => {
            // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
            onClear();
          }}
        />
      )}
    </Box>
  );
}
